import React from 'react';
import PropTypes from 'prop-types';
import CellphoneIcon from 'mdi-react/CellphoneIcon';
import CursorMoveIcon from 'mdi-react/CursorMoveIcon';
import ContentSaveOutlineIcon from 'mdi-react/ContentSaveOutlineIcon';
import ViewDashboardOutlineIcon from 'mdi-react/ViewDashboardOutlineIcon';
import DotsHorizontalCircleOutlineIcon from 'mdi-react/DotsHorizontalCircleOutlineIcon';
import LinkVariantIcon from 'mdi-react/LinkVariantIcon';
import RefreshIcon from 'mdi-react/RefreshIcon';
import UndoVariantIcon from 'mdi-react/UndoVariantIcon';
import StadiumIcon from 'mdi-react/StadiumIcon';
import { partial } from '../../util/translation/translation';
import FeatureShowcase from '../../shared/components/custom/FeatureShowcase';
import LayoutDragPreview from './LayoutDragPreview';

/**
 * How simple the app's layout is to change: drag a part where it should be
 * (home screen, bottom menu or More menu), save, and the app has it. The
 * app fetches the layout when its home screen loads, so no new app version
 * is needed: fans get it at their next start or pull to refresh.
 */
const AppLayoutShowcase = ({ collapsible, action }) => {
  const s = partial('shared');
  const columns = { available: s('Available'), active: s('Active') };
  return (
    <FeatureShowcase
      storageKey="appLayoutShowcaseHidden"
      icon={CellphoneIcon}
      title={s('layoutInfoTitle')}
      subtitle={s('layoutShowcaseSubtitle')}
      showLabel={s('layoutShowcaseShow')}
      uses={[
        {
          key: 'drag',
          step: s('showcaseStep', { step: 1 }),
          icon: CursorMoveIcon,
          label: s('layoutDragLabel'),
          text: s('layoutDragText', columns),
          preview: <LayoutDragPreview />,
          items: [
            {
              key: 'home',
              icon: ViewDashboardOutlineIcon,
              label: s('layoutItemHome'),
            },
            { key: 'tabs', icon: CellphoneIcon, label: s('layoutItemTabs') },
            {
              key: 'more',
              icon: DotsHorizontalCircleOutlineIcon,
              label: s('layoutItemMoreMenu'),
            },
            {
              key: 'links',
              icon: LinkVariantIcon,
              label: s('layoutItemLinks'),
            },
          ],
        },
        {
          key: 'save',
          step: s('showcaseStep', { step: 2 }),
          icon: ContentSaveOutlineIcon,
          label: s('layoutSaveLabel'),
          text: s('layoutSaveText'),
          cards: [
            {
              key: 'install',
              icon: RefreshIcon,
              title: s('layoutCardInstall'),
              text: s('layoutCardInstallText'),
            },
            {
              key: 'often',
              icon: StadiumIcon,
              title: s('layoutCardOften'),
              text: s('layoutCardOftenText'),
            },
            {
              key: 'undo',
              icon: UndoVariantIcon,
              title: s('layoutCardUndo'),
              text: s('layoutCardUndoText', columns),
            },
          ],
        },
      ]}
      collapsible={collapsible}
      action={action}
    />
  );
};

AppLayoutShowcase.propTypes = {
  collapsible: PropTypes.bool,
  action: PropTypes.node,
};

AppLayoutShowcase.defaultProps = {
  collapsible: true,
  action: null,
};

export default AppLayoutShowcase;
